import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionMetricsPanel = ({ metrics }) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
        Conversion Analytics
      </h2>

      <div className="space-y-4 mb-6">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600 dark:text-gray-400">Awareness → Interest</span>
          <span className="text-sm font-semibold text-emerald-600">{metrics?.awarenessToInterest}%</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600 dark:text-gray-400">Interest → Consideration</span>
          <span className="text-sm font-semibold text-emerald-600">{metrics?.interestToConsideration}%</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600 dark:text-gray-400">Consideration → Intent</span>
          <span className="text-sm font-semibold text-emerald-600">{metrics?.considerationToIntent}%</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600 dark:text-gray-400">Intent → Decision</span>
          <span className="text-sm font-semibold text-amber-600">{metrics?.intentToDecision}%</span>
        </div>
      </div>

      <div className="border-t border-gray-200 dark:border-slate-700 pt-4 mb-6">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-900 dark:text-white">Overall Conversion</span>
          <span className="text-lg font-bold text-emerald-600">{metrics?.overallConversion}%</span>
        </div>
      </div>

      {/* Bottleneck Alert */}
      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4 mb-4">
        <div className="flex items-start gap-3">
          <Icon name="AlertTriangle" size={20} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-amber-900 dark:text-amber-300 mb-1">
              Bottleneck Identified
            </h3>
            <p className="text-xs text-amber-700 dark:text-amber-400">
              {metrics?.bottleneck}
            </p>
          </div>
        </div>
      </div>

      {/* Recommendation */}
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={20} className="text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-blue-900 dark:text-blue-300 mb-1">
              Recommendation
            </h3>
            <p className="text-xs text-blue-700 dark:text-blue-400">
              {metrics?.recommendation}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionMetricsPanel;